import React, { useEffect } from 'react';
// import { useDispatch } from 'react-redux';
// import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// import { setLoginModalOpen } from '../../redux/reducers/ui/modalsReducer';
import useUserMeQuery from '../../reactQuery/hooks/useUserMeQuery';
// import PATHS from '../../lib/consts/paths';

const UserLayer = () => {
	// const location = useLocation();
	// const navigate = useNavigate();
	const { i18n } = useTranslation();

	const userFromLs = localStorage.getItem('currentUser');
	const { data, isLoading, isSuccess, isError } = useUserMeQuery({
		enabled: !!userFromLs,
	});

	useEffect(() => {
		if (isSuccess) {
			if (data) {
				setTimeout(() => {
					i18n.changeLanguage(data.language);
				}, 500);
			}
			localStorage.setItem('currentUser', JSON.stringify(data));
		}
	}, [data, isSuccess, isError, isLoading]);

	return <div style={{ width: 0, height: 0, overflow: 'hidden' }}>.</div>;
};

export default UserLayer;
